module.exports = "images/culturebox.acec6822.png";